import i18n from '@/i18n/index.js';
import {callApi} from '@/lib/api/callApi';

/**
 * 取得自己的使用者資料
 * @returns {Promise} promise
 */
async function getMe() {
  const res = await callApi({category: 'user', apiName: 'me', method: 'get'});
  res.data.profileUrl = `${
    res.data.profileUrl
  }?timestamp=${new Date().getTime()}`;
  return res.data;
}

/**
 * 取得使用者資料
 * @param {String} id id
 * @returns {Promise} promise
 */
async function getUser(id) {
  const res = await callApi({category: 'user', apiName: id, method: 'get'});
  res.data.profileUrl = `${
    res.data.profileUrl
  }?timestamp=${new Date().getTime()}`;
  return res.data;
}

/**
 * 取得使用者資料
 * @param {String} identificationNo id
 * @returns {Promise} promise
 */
async function getUsers({identificationNo, offset = 0, limit = 1}) {
  const res = await callApi({
    category: 'user',
    apiName: '',
    method: 'get',
    params: {identificationNo, offset, limit},
  });
  return res.data;
}

/**
 * 更新使用者資訊
 * @param {Object} user 要更新的user資料
 * @returns {Promise} promise
 */
async function updateUser(user) {
  const res = await callApi({
    category: 'user',
    method: 'patch',
    apiName: user.id,
    data: user,
    defaultError: null,
  });
  return res.data;
}

/**
 * 更新使用者資訊
 * @param {Object} user 要更新的user資料
 * @returns {Promise} promise
 */
async function updateUserRank({userId, rank, rankType, certUrl}) {
  const res = await callApi({
    category: 'user',
    method: 'post',
    apiName: `${userId}/rank`,
    data: {rank, rankType, certUrl},
  });
  return res.data;
}

/**
 * 使用者註冊
 * @param {Object} data 參數
 * @returns {Promise} promise
 */
async function register(data) {
  const res = await callApi({
    category: 'user',
    apiName: '',
    method: 'post',
    data,
  });
  return res.data;
}

/**
 * 取得使用者成就
 * @param {String} id 參數
 * @param {Number} limit 限制筆數
 * @param {Number} offset 已取出幾筆
 * @returns {Promise} promise
 */
async function getAchievement({id, limit, offset}) {
  const res = await callApi({
    category: 'user',
    apiName: `${id}/achievements`,
    method: 'get',
    params: {limit, offset},
    defaultError: '載入成就失敗',
  });
  return res.data;
}

/**
 * 取得使用者付款紀錄
 * @param {Object} params 參數
 * @returns {Promise} promise
 */
async function getOrders(params) {
  const res = await callApi({
    category: 'user',
    apiName: `${params.id}/orders`,
    method: 'get',
    params,
    defaultError: i18n.t('載入付款紀錄失敗'),
  });
  return res.data;
}

/**
 * getUserPopupRecords
 * @param {String} userId userId
 * @param {Array} types types
 * @returns {Promise} promise
 */
async function getUserPopupRecords({userId, types}) {
  const res = await callApi({
    category: 'user',
    method: 'get',
    apiName: `${userId}/popup`,
    params: {types},
    defaultError: null,
  });
  return res.data;
}

/**
 * upsertUserPopupRecords
 * @param {String} userId userId
 * @param {String} type type
 * @returns {Promise} promise
 */
async function upsertUserPopupRecords({userId, type}) {
  const res = await callApi({
    category: 'user',
    method: 'post',
    apiName: `${userId}/popup`,
    data: {type},
    defaultError: null,
  });
  return res.data;
}

export default {
  getUser,
  getUsers,
  getMe,
  register,
  updateUser,
  getAchievement,
  getOrders,
  updateUserRank,
  getUserPopupRecords,
  upsertUserPopupRecords,
};
